<mat-dialog-actions class="dialog-close">
    <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close class="dialog-close-img"
        (click)="dialogClose()" (keydown.enter)="dialogClose()" (keydown.space)="dialogClose()">
</mat-dialog-actions>

<div class="dialog-content select-line-popup">
    <div class="dialog-title">
        <span>
            {{'machine_view.select_line' | translate}}
        </span>
    </div>
</div>

<div class="dialog-content select-line-popup">
    <div class="dialog-form">
        <form (ngSubmit)="onSubmit()" [formGroup]="lineSelectors">
            <div class="common-form-field selection-wrapper">
                <mat-form-field appearance="outline" class="fw selection-form-field">
                    <mat-label>
                        {{'report.table_header_cluster' | translate}}
                    </mat-label>
                    <input type="text" matInput formControlName="cluster" [matAutocomplete]="clusterAuto"
                        (ngModelChange)="autoCompleteCluster($event)" (change)="valueReset('cluster')">
                    <mat-autocomplete #clusterAuto="matAutocomplete">
                        <mat-option *ngFor="let clusterOption of uniqueLineCluster"
                            [value]="clusterOption?.subRegionName" (click)="onClusterChanged(clusterOption)"
                            (keydown)="onClusterChanged(clusterOption)">
                            {{clusterOption.subRegionName}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="end" class="error" *ngIf="lineSelectors?.controls?.clusterid.hasError('required')">
                        {{'report.please_select_from_list' | translate}}!
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="selection-wrapper common-form-field">
                <mat-form-field appearance="outline" class="selection-form-field fw">
                    <mat-label>
                        {{'report.table_header_factory' | translate}}
                    </mat-label>
                    <input type="text" matInput formControlName="factory" (change)="valueReset('factory')"
                        [matAutocomplete]="factoryAuto" (ngModelChange)="autoCompleteFactory($event)">
                    <mat-autocomplete #factoryAuto="matAutocomplete">
                        <mat-option *ngFor="let factoryOption of selectedClusterFactory"
                            (click)="onFactoryChanged(factoryOption)" (keydown)="onFactoryChanged(factoryOption)"
                            [value]="factoryOption?.name">
                            {{factoryOption.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint class="error" align="end" *ngIf="lineSelectors?.controls?.factoryid.hasError('required') &&
                        lineSelectors?.controls?.factory.status=='VALID'">
                        {{'report.please_select_from_list' | translate}}!</mat-hint>
                </mat-form-field>
            </div>

            <div class="selection-wrapper common-form-field">
                <mat-form-field appearance="outline" class="selection-form-field fw">
                    <mat-label>
                        {{'report.table_header_line' | translate}}
                    </mat-label>
                    <input type="text" matInput [matAutocomplete]="lineAuto" formControlName="line"
                        (change)="valueReset('line')">
                    <mat-autocomplete #lineAuto="matAutocomplete">
                        <mat-option *ngFor="let lineOption of lineFilteredOptions | async"
                            (click)="onLineChanged(lineOption)" (keydown)="onLineChanged(lineOption)"
                            [value]="lineOption?.name">
                            {{lineOption.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint class="error" align="end" *ngIf="lineSelectors?.controls?.lineid.hasError('required') &&
                        lineSelectors?.controls?.line.status=='VALID'">
                        {{'report.please_select_from_list' | translate}}!</mat-hint>
                </mat-form-field>
            </div>

            <div class="text-align-center">
                <button mat-raised-button [ngClass]="{'submit-btn' : lineSelectors.valid}" color="primary"
                    [disabled]="!lineSelectors.valid" type="submit">
                    {{'common.submit' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>